export default "__VITE_ASSET__37299063__"